import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-[10px] uppercase" }

import { CardMenu } from '@/components/ui/card';
    import { createVoucherEarlierReleasesColumns } from '@/tables/columns/voucher-earlier-releases';
    import { computed } from 'vue';
    import { DatePicker } from '@/components/ui/form';
    import { Head } from '@inertiajs/vue3';
    import { ref } from 'vue';
    import { today, getLocalTimeZone } from '@internationalized/date';
    import { usePage } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableSearchButton from '@/components/datatable/DataTableSearchButton.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem, NavItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherEarlierReleases',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const startDate = ref<string>(today(getLocalTimeZone()).subtract({ years: 1 }).toString());
    const endDate = ref<string>(today(getLocalTimeZone()).toString());

    const { data: economicDimensions, isPending: isPendingDimensions } = useQuery({
        queryKey: ['economic-dimensions', selectedCompanyId],
        queryFn: async () => {
            if (!selectedCompanyId.value) return [];
            const { data } = await axios.get(route('v2.companies.get', selectedCompanyId.value));
            return data.economic_dimensions || [];
        },
        enabled: computed(() => !!selectedCompanyId.value),
        placeholderData: [],
        retry: 1,
        refetchOnMount: true,
    });

    const columns = computed(() => createVoucherEarlierReleasesColumns(economicDimensions.value || []));

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'vouchers.page_header',
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'vouchers.current_vouchers.header',
            href: route('v2.vouchers.index'),
            permissionLevel: Permission.VOUCHERS_VIEW,
        },
        {
            title: 'vouchers.earlier_releases.header',
            href: route('v2.vouchers.earlier-releases.index'),
            permissionLevel: Permission.VOUCHERS_EARLIER_RELEASES_VIEW,
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.VOUCHERS_EARLIER_RELEASES, selectedCompanyId],
        queryFn: getVouchers,
    });

    async function getVouchers() {
        const { data } = await axios.post(
            route('v2.vouchers.earlier-releases.load-table', selectedCompanyId.value),
            {
                from: startDate.value,
                to: endDate.value,
            },
        );
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('vouchers.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).VOUCHERS_EARLIER_RELEASES,
              columns: columns.value,
              data: _unref(data),
              loading: _unref(isPending) || _unref(isPendingDimensions),
              "default-sorting": [
                    {
                        id: 'Date',
                        desc: false,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardMenu), { items: navItems })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "vouchers-earlier-releases" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('activities.date_selection')), 1),
                    _createVNode(_unref(DatePicker), {
                      modelValue: startDate.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[2] || (_cache[2] = _createTextVNode(" - ")),
                    _createVNode(_unref(DatePicker), {
                      modelValue: endDate.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(DataTableSearchButton, {
                      onRefetch: _unref(refetch),
                      "is-fetching": _unref(isFetching)
                    }, null, 8, ["onRefetch", "is-fetching"])
                  ]),
                  _: 1,
                  __: [2]
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})